export const TITLE = "Details";
export const INPUT_LABEL_1 = "Name";
export const INPUT_LABEL_2 = "DOB";
export const INPUT_LABEL_3 = "Time of Birth";
export const INPUT_LABEL_4 = "Place of Birth";
export const INPUT_LABEL_5 = "Gender";
export const INPUT_LABEL_6 = "First Name";
export const INPUT_LABEL_7 = "Last Name";
export const INPUT_LABEL_8 = "Varshaphal Year";
export const INPUT_LABEL_9 = "Pick Zodiac Sign";
export const INPUT_LABEL_10 =
  "Find latitude, longitude, and time-zone for your city";
export const COLORS = [
  "#F456981A",
  "#815EF21A",
  "#33B1DC1A",
  "#ff613219",
  "#13c19919",
  "#c98b7919",
];
